function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 38,
    height: 38,
    fill: "#fff",
    stroke: "#fff",
    viewBox: "0 0 455 455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v455h455V0H0zm384.814 100.68-53.458 257.136c-1.259 6.071-8.378 8.822-13.401 5.172l-72.975-52.981a12.065 12.065 0 0 0-14.712.412l-40.46 32.981c-4.695 3.84-11.771 1.7-13.569-4.083l-28.094-90.351-72.583-27.089c-7.373-2.762-7.436-13.171-.084-16.003L373.36 90.959c6.315-2.442 12.83 3.09 11.454 9.721z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.567 147.179-141.854 87.367c-5.437 3.355-7.996 9.921-6.242 16.068l15.337 53.891c1.091 3.818 6.631 3.428 7.162-.517l3.986-29.553a24.27 24.27 0 0 1 7.522-14.522l117.069-108.822c2.192-2.03-.432-5.477-2.98-3.912z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.bcc6ff107fead52fed88295c3dd46a1c.svg";
export { ForwardRef as ReactComponent };